import * as React from 'react'
import Menu from '@mui/material/Menu'
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
// import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

import { Box } from '@mui/system'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useStyles from './useStyles'
import StepperSeeMoreOrganization from '../../../../../components/Modals/Users/Suscribers/SeeMoreOrganization'

export default function ModalMenuItem ({ item, setLoading }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const [stateSeeMore, setstateSeeMore] = useState(false)

  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const listSeeMoreOrganization = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 800 }}
      role="presentation"
    >
      <StepperSeeMoreOrganization
        setstateSeeMore={setstateSeeMore}
        item={item}
        setLoading={setLoading}
      />
    </Box>
  )

  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickMenu}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
        />
      </Menu>

      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreOrganization('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({
  item,

  onClose,
  setstateSeeMore
}) {
  const classes = useStyles()
  const navigate = useNavigate()
  return (
    <Box className={classes.boxStyle}>
      <IconButton
        onClick={() => {
          setstateSeeMore(true)
          onClose()
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>

      <IconButton
        onClick={() =>
          navigate(`/organizations/${item.organizationId}/subscribers`)
        }
      >
        <Box className={classes.boxTypography}>
          <PeopleOutlineOutlinedIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Ver suscriptores
          </Typography>
        </Box>
      </IconButton>

      <IconButton
        onClick={() => navigate(`/organizations/${item.organizationId}/users`)}
      >
        <Box className={classes.boxTypography}>
          <PersonOutlineIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Ver usuarios
          </Typography>
        </Box>
      </IconButton>

       <IconButton
        onClick={() => navigate(`/ME/applicationInstances/${item.organizationId}/instance`)}
      >
        <Box className={classes.boxTypography}>
          <PersonOutlineIcon className={classes.hoverButton} />
          <Typography className={classes.typographyStyle}>
            Ver instancias ME
          </Typography>
        </Box>
      </IconButton>
    </Box>
  )
}
